// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2QQ0rU04 flex","logo":"_24ZpQkll","button":"_3tI5MY8J flex flex-auto items-center justify-center bold"};